<template>
    <div id="careerSearchNormal">
        <div class="college_info padding-left w-100 margin-top">
            <h3  class="title">{{occupationDetail.name}}</h3>
            <p>{{occupationDetail.categoryName}}</p>
        </div>
        <div class="text-center menuStyle" :class="gudMenu?'gud':''">
            <span :key="index" v-for="(item,index) in getLeftDirectoryList">
                <span class="margin-right cursorSz"  @click="selectDirectory(item)">
                    {{item }}
                </span>
                <span class="margin-right"
                      v-show="index<getLeftDirectoryList.length-1">|</span>
            </span>
        </div>
        <div class="college_tab commonBackground margin-top  ">
            <div class="g-wrapper">
                <div class="content padding-b-x w-100">
                    <div   class="overview">
                        <div v-show="getDirectoryName==='职业简介'" class="main">
                            <div  class="item introduction">
                                <div style="min-height: 125px;" class="position-relative">
                                    <div  class="con" >
                                        <div  class="info">
                                            <div class="sonTitle font-weight-bolder text-m-size">职业简介</div>
                                            <div v-show="getJobJj!==''&&!loadingDetail"  class="contents" v-html="getJobJj">

                                            </div>
                                            <empty v-show="getJobJj===''&&!loadingDetail" :text-size="18"  content="暂无相关职业简介"></empty>
                                            <loading :show="loadingDetail" ></loading>
                                        </div>
                                    </div>
                                </div>
                                <div style="min-height: 125px;" class="position-relative">
                                    <div  class="con" >
                                        <div  class="info">
                                            <div class="sonTitle font-weight-bolder text-m-size">工作内容</div>
                                            <div v-show="getJobContent!==''&&!loadingDetail"  class="contents" v-html="getJobContent">

                                            </div>
                                            <empty v-show="getJobContent===''&&!loadingDetail" :text-size="18" content="暂无相关工作内容"></empty>
                                            <loading :show="loadingDetail" ></loading>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="getDirectoryName==='从业资格'" class="main">
                            <div  class="item introduction">
                                <div style="min-height: 125px;" class="position-relative">
                                    <div  class="con" >
                                        <div  class="info">
                                            <div class="sonTitle font-weight-bolder text-m-size">从业资格</div>
                                            <div v-show="olRequirementsData!==''&&!loadingolRequirementsData"  class="contents" v-html="olRequirementsData">

                                            </div>
                                            <empty v-show="olRequirementsData===''&&!loadingolRequirementsData" :text-size="18"  content="暂无从业资格说明"></empty>
                                            <loading :show="loadingolRequirementsData" ></loading>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div v-show="getDirectoryName==='发展现状及前景'" class="main">
                            <div  class="item introduction">
                                <div style="min-height: 125px;" class="position-relative">
                                    <div  class="con" >
                                        <div  class="info">
                                            <div class="sonTitle font-weight-bolder text-m-size">发展现状及前景</div>
                                            <div v-show="prospectData!==''&&!loadingProspectData"  class="contents" v-html="prospectData">

                                            </div>
                                            <empty v-show="prospectData===''&&!loadingProspectData" :text-size="18"  content="暂无内容"></empty>
                                            <loading :show="loadingProspectData" ></loading>
                                        </div>
                                    </div>
                                </div>
                                <div style="min-height: 125px;" class="position-relative">
                                    <div  class="con" >
                                        <div  class="info">
                                            <div class="sonTitle font-weight-bolder text-m-size">小贴士</div>
                                            <div v-show="prospectTip!==''&&!loadingProspectData" class="contents" v-html="prospectTip">

                                            </div>
                                            <empty v-show="prospectTip===''&&!loadingProspectData" :text-size="18"  content="暂无内容"></empty>
                                            <loading :show="loadingProspectData" ></loading>
                                        </div>
                                    </div>
                                </div>
                               <div style="min-height: 125px;" class="position-relative">
                                    <div  class="con" >
                                        <div  class="info">
                                            <div class="sonTitle font-weight-bolder text-m-size">职业发展案例</div>
                                            <div v-show="zcAlData!==null&&!loadingProspectData"  class="contents" v-html="zcAlData">
                                            </div>
                                            <empty v-show="zcAlData===null&&!loadingProspectData" :text-size="18"  content="暂无内容"></empty>
                                            <loading :show="loadingProspectData" ></loading>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div v-show="getDirectoryName==='职业视频'" class="main">
                            <div  class="item introduction">
                                <div style="min-height: 125px;" class="position-relative">
                                    <div  class="con" >
                                        <div  class="info videoSmallBox">
                                            <div class="sonTitle font-weight-bolder text-m-size">职业视频</div>
                                            <div id='J_prismPlayer' class='prism-player' style="visibility: visible;width:890px;height:500px;" v-show="occupationVideo!==null&&!loadingVideo">
                                            </div>
                                            <empty v-show="occupationVideo===null&&!loadingVideo" :text-size="18"  content="暂无内容"></empty>
                                            <loading :show="loadingVideo" ></loading>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        occupationIntro,
        occupationJobCase,
        occupationJobVideo,
        occupationProspect,
        occupationQualification
    } from "../../../config";
    export default {
        name: "careerSearchNew",
        data(){
            return{
                gudMenu:false,
                occupationDetailId:'',
                getLeftDirectoryList:['职业简介','从业资格','发展现状及前景','职业视频'],
                // getLeftDirectoryList:['职业简介','从业资格','发展现状及前景'],
                getDirectoryName:'职业简介',
                occupationDetail:'',
                //职业简介加载
                loadingDetail:false,
                //获取职业简介
                getJobJj:'',
                //获取工作内容
                getJobContent:'',
                loadingContent:false,
                /*********从业资格相关内容*/
                //从业资格详情
                olRequirementsData:'',
                loadingolRequirementsData:false,
                /****职业发展前景****/
                prospectData:'',
                prospectTip:'',
                //职场案例
                zcAlData:[],
                loadingProspectData:false,
                /**********职场视频****/
                occupationVideo:'',
                loadingVideo:false
            }
        },
        mounted(){
            this.occupationDetailId=this.$route.query.occupationId;
            this.defaultSearchJobBI();
            window.onscroll=(()=>{
                if(window.pageYOffset>=178){
                    this.gudMenu=true;
                }else{
                    this.gudMenu=false;
                }
            })
        },
        beforeRouteLeave(to,from,next){
          window.onscroll=(()=>{

          })
            next();
        },
        methods:{
            //查出左侧目录内容
            selectDirectory(val){
                this.getDirectoryName=val;
                if(val==='从业资格'){
                    if(this.olRequirementsData===''){
                        this.olRequirements();
                    }
                }else if(val==='发展现状及前景'){
                    if(this.prospectData===''){
                        this.developmentProspect();
                        this.zcAl();
                    }
                }else if(val==='职业视频'){
                    if(this.occupationVideo===''){
                        this.getVideo();
                    }
                }
            },
            //默认查出职业简介
            async defaultSearchJobBI(){
                this.loadingolRequirementsData=true;
                let result=await occupationIntro(this.occupationDetailId);
                if(result.status){
                    this.loadingolRequirementsData=false;
                    this.getJobJj=result.data.introduce;
                    this.getJobContent=result.data.jobContent;
                    this.occupationDetail=result.data;
                }else{
                    this.loadingolRequirementsData=false;
                }
            },
            //从业资格
            async olRequirements(){
                let result=await occupationQualification(this.occupationDetailId);
                if(result.status){
                    this.olRequirementsData=result.data.qualification;
                }else{

                }
            },
            //职业发展前景
            async developmentProspect(){
                this.loadingProspectData=true;
                let result=await occupationProspect(this.occupationDetailId);
                if(result.status){
                    this.loadingProspectData=false;
                    this.prospectData=result.data.prospect;
                    this.prospectTip=result.data.tip;
                }else{
                    this.loadingProspectData=false;
                }
            },
            //职场案例
            async zcAl(){
                let result=await occupationJobCase(this.occupationDetailId);
                if(result.status){

                    this.zcAlData=result.data;
                }else{

                }
            },
            //查出职场视频
            async getVideo(){
                this.loadingVideo=true;
                let result=await occupationJobVideo(this.occupationDetailId);
                if(result.status){
                    this.loadingVideo=false;
                    this.occupationVideo=result.data;
                }else{
                    this.loadingVideo=false;
                }
            },
            commonPlayVideo(){
                var player = new Aliplayer({
                    id: "J_prismPlayer",     // 容器id
                    vid: this.videoId,      //媒体转码服务的媒体Id
                    playauth: this.playAuth,//播放鉴权 [playauth参照](https://help.aliyun.com/document_detail/52833.html?spm=5176.doc51236.6.627.5gm5gf)
                    width: "890px",
                    height: "500px",
                    useH5Prism: true,
                    controlBarVisibility: "hover",
                    playsinline: true,
                    definition: 'FD,LD,SD',
                    defaultDefinition: 'SD'
                });
                player.autoplay = false;
            },
        }
    }
</script>

<style scoped lang="scss">
    .menuStyle.gud{
        position: fixed;
        top:70px;
        width: calc(100vw - 260px);
        z-index: 999;
        margin-right: 30px;
    }
    .college_tab{

        .g-wrapper{
            .tab{

            }
            .content{

                .overview{
                    >.title{
                        color:#2196f3;
                        font-size: 20px;
                    }
                    >p{
                        color:#2196f3;
                    }
                }
                .item{
                    .con{
                        .contents{
                            color:#333333;
                        }
                    }
                }
            }
        }
    }
</style>
